import React from 'react';
import { siteConfig } from '../../../config/site';

const AboutUs = () => {
  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <h2 className="text-4xl font-bold text-gray-900 leading-tight">
              Quem Somos
            </h2>
            <div className="w-20 h-1.5 bg-blue-600 rounded-full"></div>
            <p className="text-lg text-gray-600 leading-relaxed">
              A <span className="font-bold text-blue-900">{siteConfig.name}</span> é uma empresa líder em serviços técnicos residenciais, especializada na instalação e manutenção de eletrodomésticos com os mais altos padrões de segurança e qualidade.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Com anos de experiência no mercado português, a nossa missão é facilitar a vida dos nossos clientes, garantindo que os seus equipamentos sejam instalados de forma correta e eficiente, evitando avarias futuras e garantindo a validade da garantia do fabricante.
            </p>
            <div className="grid grid-cols-2 gap-6 pt-4">
              <div className="border-l-4 border-blue-600 pl-4">
                <h4 className="text-3xl font-bold text-gray-900">10+</h4>
                <p className="text-gray-500 uppercase tracking-wider text-sm font-semibold">Anos de Experiência</p>
              </div>
              <div className="border-l-4 border-blue-600 pl-4">
                <h4 className="text-3xl font-bold text-gray-900">5000+</h4>
                <p className="text-gray-500 uppercase tracking-wider text-sm font-semibold">Instalações Realizadas</p>
              </div>
            </div>
          </div>

          {/* Image/Visual Content */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="/images/alpha services/Máquina de Lavar Roupa.webp" 
                alt="Nossa Equipa" 
                className="w-full h-full object-cover aspect-[4/3]"
              />
            </div>
            {/* Experience Badge */}
            <div className="absolute -bottom-6 -left-6 bg-blue-600 text-white p-8 rounded-2xl shadow-xl hidden md:block">
              <p className="text-sm font-medium uppercase tracking-widest opacity-80 mb-1">Compromisso</p>
              <p className="text-2xl font-bold italic">"Qualidade e Segurança em cada detalhe."</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
